import { defineComponent as _defineComponent } from 'vue';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { EnButton } from 'Components/base/EnButton';
import EnCheckboxButton from 'Components/inputs/EnCheckbox/EnCheckbox.vue';
import { ListFilter, EyeOff, Eye, FunnelX } from 'lucide-vue-next';
import { EnMenu, MenuSeparator } from 'Components/base/EnMenu';
import { EnItem } from 'Components/base/EnItem';
import { EnOverlayBadge } from 'Components/badge/EnOverlayBadge';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnFilterVisibilityMenu',
    props: {
        filterButtons: (Array),
        resetFilters: Function,
        resetIndividualFilter: Function
    },
    emits: ['click'],
    setup(__props, { expose: __expose, emit: __emit }) {
        __expose();
        const { t } = useI18n();
        const props = __props;
        const emit = __emit;
        const menuComponent = ref();
        /**
         * Dynamically computes if all filters are currently visible.
         */
        const allFiltersVisible = computed(() => {
            if (!Array.isArray(props.filterButtons)) {
                return false;
            }
            return props.filterButtons.every(filterButton => filterButton.visible);
        });
        const anyFiltersVisible = computed(() => {
            if (!Array.isArray(props.filterButtons)) {
                return false;
            }
            return props.filterButtons.some(filterButton => filterButton.visible);
        });
        /**
         * Computes the number of active filters.
         */
        const activeFilterCount = computed(() => {
            if (!Array.isArray(props.filterButtons)) {
                return 0;
            }
            return props.filterButtons.filter(filterButton => filterButton.visible).length;
        });
        /**
         * This function toggles the visibility of a filter and optionally resets it.
         * @param filterButton
         */
        const toggleIndividualFilter = (filterButton) => {
            filterButton.visible = !filterButton.visible;
            if (!filterButton.visible) {
                props.resetIndividualFilter(filterButton.key);
                return;
            }
            // Ensure the filter does not automatically open on render when user toggles it.
            filterButton.openOnRender = false;
        };
        /**
         * This function hides and shows all filters at once.
         */
        const toggleAllFilters = () => {
            menuComponent.value.setOpen(false);
            const newVisibilityState = !allFiltersVisible.value;
            props.filterButtons.forEach(filterButton => {
                if (!newVisibilityState) {
                    props.resetFilters();
                }
                filterButton.visible = newVisibilityState;
                filterButton.openOnRender = false;
            });
        };
        /**
         * Handles the click event on the filter visibility button.
         * Emits a 'click' event to notify parent components.
         * @param {Event} event - The click event.
         */
        function handleClick(event) {
            emit('click', event);
        }
        function clearFilters() {
            menuComponent.value.setOpen(false);
            props.resetFilters?.();
        }
        const __returned__ = { t, props, emit, menuComponent, allFiltersVisible, anyFiltersVisible, activeFilterCount, toggleIndividualFilter, toggleAllFilters, handleClick, clearFilters, get EnButton() { return EnButton; }, EnCheckboxButton, get ListFilter() { return ListFilter; }, get EyeOff() { return EyeOff; }, get Eye() { return Eye; }, get FunnelX() { return FunnelX; }, get EnMenu() { return EnMenu; }, get MenuSeparator() { return MenuSeparator; }, get EnItem() { return EnItem; }, get EnOverlayBadge() { return EnOverlayBadge; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
